<template>
  <eden-master-search
    separator-text="Resultado"
    :page-config="pageConfig"
    :page-actions-config="headerActions"
    :academic-years="options.academicYears"
    :create-report-visible="createReportVisible"
    :report-available-academic-years="options.reportAvailableAcademicYears"
    :data="resultData"
    :pagination-page-size="pageSize"
    :selected-academic-year="filter.academicYear"
    :eden-report-type-id="edenTypesEnum.DisputeResolution"
    :row-actions="rowActions"
    :show-updated-date="true"
    @on-create-report="onOpenCreateReportHandler"
    @on-cancel-report="onCancelCreateReportHandler"
    @on-continue-create-report="onContinueCreateReportHandler"
    @on-search-result="getSearchResult(1)"
    @on-change-page="getSearchResult($event.pageIndex)"
    @on-enter="onEnterHandler($event)"
    @on-change-academic-year="onChangeAcademicYearHandler"
    @on-publish-data="onPublishDataHandler"
  />
</template>

<script>
import storeMixin from "utils/mixins/storeGenerator";
import EdenMasterSearch from "../shared/components/EdenMasterSearch.vue";
import Service from "@/services/api/edendisputeResolution.api";

//constants
import edenTypes from '@/utils/constants/edenTypes.js'
const STORE_MODULE_NAME = "edenDisputeResolutionModule";

export default {
  name: "MainDisputeResolution",
  components: {
    EdenMasterSearch,
  },
  mixins: [storeMixin],
  data: () => ({
    moduleName: STORE_MODULE_NAME,
    filter: {
      academicYear: null,
    },
    options: {
      academicYears: [],
      reportAvailableAcademicYears: [],
    },
    resultData: {
      result: [],
      pagination: {},
    },
    createReportVisible: null,
  }),
  computed: {
    pageSize() {
      return 10;
    },
    pageConfig() {
      return {
        title: "Dispute Resolution (Querellas)",
        icon: "fas fa-calculator",
        routes: ["Inicio", "618 Data", " Dispute Resolution (Querellas)"],
      };
    },
    headerActions() {
      return [
        {
          text: "Crear Reporte",
          icon: "fas fa-file-plus pr-2",
          variant: "success",
          visible: !this.createReportVisible,
          click: () => this.onOpenCreateReportHandler(),
        },
      ];
    },
    edenTypesEnum() {
      return edenTypes
    },
    rowActions() {
      return [
        {
          text: "Entrar",
          icon: "fas fa-file-import",
          classIcon: "text-green",
          click: (row) => this.onEnterHandler(row.id),
        },
        {
          text: "Historial",
          icon: "fas fa-clock",
          classIcon: "text-green",
          click: (row) => this.onHistoryHandler(row),
        },
      ];
    },
  },
  async mounted() {
    await this.getInit();
  },
  destroyed() {
    this.persistData();
  },
  methods: {
    async getInit() {
      await this.getAvailableAcademicYears();
      await this.getSearchResult();
    },
    async getAvailableAcademicYears() {
      this.options.academicYears = (
        await Service.getAvailableAcademicYears()
      ).data;
    },
    async getSearchResult(pageIndex = 1) {
      const payload = {
        AcademicYearId: this.filter.academicYear?.id,
        PageIndex: pageIndex,
        PageSize: this.pageSize,
      };
      var { data: response } = await Service.getEdenDisputeResolutions(payload);
      const rows = response?.data
        ? response.data.map((x) => {
            return {
              ...x,
              showHistory: false,
            };
          })
        : [];
      this.resultData = {
        result: rows,
        pagination: {
          ...this.resultData.pagination,
          currentPage: response.currentPage,
          totalItemCount: response.totalItemCount,
          pageCount: response.pageCount,
          count: response.count,
          perPage: this.pageSize,
        },
      };
    },
    onCancelCreateReportHandler() {
      this.createReportVisible = false;
    },
    async onOpenCreateReportHandler() {
      this.options.reportAvailableAcademicYears =
        (await Service.getReportAvailableAcademicYears()).data || [];
      this.createReportVisible = true;
    },
    async onContinueCreateReportHandler(academicYearId) {
      if (academicYearId) {
        await Service.createEdenDisputeResolutionReport(academicYearId)
          .then(async ({ data }) => {
            if (data) {
              this.ShowToast(
                "Proceso Exitoso",
                "El reporte ha sido creado exitosamente.",
                "success"
              );
              this.onCancelCreateReportHandler();
              this.onEnterHandler(data);
            }
          })
          .catch((err) => {
            this.ShowToast("", err.response?.data?.message, "error");
          });
      }
    },
    onEnterHandler(edenDisputeResolutionId) {
      this.$router.push({
        name: "edenDisputeResolutionDetails",
        params: {
          id: edenDisputeResolutionId,
        },
      });
    },
    onChangeAcademicYearHandler(value) {
      this.filter.academicYear = value;
    },
    onHistoryHandler(row) {
      // Cerrar otros historiales abiertos
      this.resultData.result.forEach(r => {
        if (r.id !== row.id) {
          r.showHistory = false;
        }
      });
      // Toggle del historial actual
      row.showHistory = !row.showHistory;
      this.$forceUpdate();
    },
    async onPublishDataHandler() {
    }
  },
};
</script>

<style></style>
